/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum ResourcesActions {
  SET_THUMBNAILS_VERSION = 'SET_THUMBNAILS_VERSION',
}

export type ResourcesState = {
  thumbnailsVersion: undefined | number | string;
};

type SetThumbnailsVersionAction = {
  type: ResourcesActions.SET_THUMBNAILS_VERSION;
  payload: { thumbnailsVersion: ResourcesState['thumbnailsVersion'] };
};

export type ResourcesActionTypes = SetThumbnailsVersionAction;
